/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 메뉴아이템을 타입에 따라 정의한다.
 *
 * @file /src/components/menu/elements/Items.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 5. 4.
 */
import { Item } from './Item';
import * as separator from './items/Separator';
import * as button from './items/Button';
import * as filter from './items/Filter';
import * as custom from './items/Custom';

export type Properties =
    | (Omit<button.Properties<button.Button>, 'type'> & { type?: 'button' })
    | filter.Properties<filter.Filter>
    | custom.Properties<custom.Custom>
    | '-';

export type Types = 'button' | 'filter' | 'custom';
export type MenuTypes<T extends Types> = T extends 'button'
    ? button.Button
    : T extends 'filter'
    ? filter.Filter
    : custom.Custom;

export class Items {
    /**
     * 메뉴아이템 초기설정을 받아 적절하게 메뉴아이템 객체를 초기화한다.
     *
     * @param properties - 메뉴아이템 설정
     * @returns 메뉴아이템
     */
    static get(properties: Properties): Item {
        if (properties == '-') {
            return new separator.Separator();
        } else {
            properties.type ??= 'button';
            switch (properties.type) {
                case 'button':
                    return new button.Button(properties as button.Properties<button.Button>);
                case 'custom':
                    return new custom.Custom(properties);
            }
        }
    }
}
